(function () {
  var MOBILE_MQ = window.matchMedia("(max-width: 767px)");
  var SELECT_NONE_LABEL = "Select none";

  function isMobileContact() {
    return MOBILE_MQ.matches;
  }

  function serializeContactExtras(form) {
    var bodyField = form.querySelector('[name="contact[body]"]');
    if (!bodyField) return;

    var parts = [];
    var company = form.querySelector("[data-b2b-company]");
    if (company && company.value.trim()) {
      parts.push("Organization: " + company.value.trim());
    }

    var useCases = [];
    form.querySelectorAll(".b2b-contact__check-input:checked").forEach(function (input) {
      if (input.value) useCases.push(input.value);
    });
    if (useCases.length) {
      parts.push("Use cases: " + useCases.join(", "));
    }

    if (!parts.length) return;

    var extra = parts.join("\n");
    var existing = bodyField.value.trim();
    if (existing && existing.indexOf(extra) === -1) {
      bodyField.value = extra + "\n\n" + existing;
    } else if (!existing) {
      bodyField.value = extra;
    }
  }

  function getUseCaseInputs(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(".b2b-contact__check-input[data-b2b-use-case]")
    );
  }

  function getPlaceholder(labelEl) {
    var desktopDefault =
      labelEl.getAttribute("data-default-desktop") || "Select all that apply";
    var mobileDefault =
      labelEl.getAttribute("data-default-mobile") || "I am a sleep researcher";
    return isMobileContact() ? mobileDefault : desktopDefault;
  }

  function syncListboxOptions(root) {
    getUseCaseInputs(root).forEach(function (input) {
      var option = input.closest('[role="option"]');
      if (option) {
        option.setAttribute("aria-selected", input.checked ? "true" : "false");
      }
    });
  }

  function updateDropdownLabel(root) {
    var labelEl = root.querySelector("[data-b2b-dropdown-label]");
    if (!labelEl) return;

    var inputs = getUseCaseInputs(root);
    var placeholder = getPlaceholder(labelEl);
    var selected = [];

    inputs.forEach(function (input) {
      if (input.checked && input.value) selected.push(input.value);
    });

    if (inputs.length > 0 && selected.length === inputs.length) {
      labelEl.textContent = SELECT_NONE_LABEL;
      return;
    }

    if (selected.length === 0) {
      labelEl.textContent = placeholder;
      return;
    }

    if (selected.length === 1) {
      labelEl.textContent = selected[0];
      return;
    }

    if (selected.length === 2) {
      labelEl.textContent = selected.join(", ");
      return;
    }

    labelEl.textContent = selected.length + " selected";
  }

  function setAllUseCases(root, checked) {
    getUseCaseInputs(root).forEach(function (input) {
      input.checked = checked;
    });
    syncListboxOptions(root);
    updateDropdownLabel(root);
  }

  function handleLabelClick(root, labelEl) {
    var inputs = getUseCaseInputs(root);
    var labelText = labelEl.textContent.trim();
    var placeholder = getPlaceholder(labelEl);

    if (labelText === SELECT_NONE_LABEL) {
      setAllUseCases(root, false);
      return true;
    }

    if (
      labelText === placeholder &&
      inputs.length > 0 &&
      inputs.every(function (input) {
        return !input.checked;
      })
    ) {
      setAllUseCases(root, true);
      return true;
    }

    return false;
  }

  function initUseCaseDropdowns() {
    document.querySelectorAll("[data-b2b-use-case-dropdown]").forEach(function (root) {
      var trigger = root.querySelector(".b2b-contact__dropdown-trigger");
      var panel = root.querySelector(".b2b-contact__dropdown-panel");
      var labelEl = root.querySelector("[data-b2b-dropdown-label]");
      if (!trigger || !panel || !labelEl) return;

      function keepOpen() {
        trigger.setAttribute("aria-expanded", "true");
        panel.classList.add("is-open");
        root.classList.add("is-open");
      }

      if (!root.dataset.bound) {
        root.dataset.bound = "true";

        labelEl.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          handleLabelClick(root, labelEl);
        });

        trigger.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (event.target.closest("[data-b2b-dropdown-label]")) return;
          keepOpen();
        });

        trigger.addEventListener("keydown", function (event) {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleLabelClick(root, labelEl);
          }
        });

        getUseCaseInputs(root).forEach(function (input) {
          input.addEventListener("change", function () {
            syncListboxOptions(root);
            updateDropdownLabel(root);
          });
        });

        function onMqChange() {
          updateDropdownLabel(root);
        }

        if (MOBILE_MQ.addEventListener) {
          MOBILE_MQ.addEventListener("change", onMqChange);
        } else if (MOBILE_MQ.addListener) {
          MOBILE_MQ.addListener(onMqChange);
        }
      }

      updateDropdownLabel(root);
      keepOpen();
    });
  }

  function initContactForms() {
    document.querySelectorAll(".b2b-contact__form").forEach(function (form) {
      if (form.dataset.serializeBound) return;
      form.dataset.serializeBound = "true";
      form.addEventListener("submit", function () {
        serializeContactExtras(form);
      });
    });
  }

  function initAll() {
    initUseCaseDropdowns();
    initContactForms();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
